import { _ as o } from "./index.es397.js";
import { _ as r } from "./index.es398.js";
import { _ as e } from "./index.es399.js";
var i = o, a = r, n = e;
function p(t) {
  return typeof t.constructor == "function" && !n(t) ? i(a(t)) : {};
}
var m = p;
export {
  m as _
};
//# sourceMappingURL=index.es264.js.map
